import { useMutation } from '@tanstack/react-query';
import { captureException } from '@sentry/react';
import { CustomError } from 'typescript/utilities/custom_error';
import { validateAddress as clientValidateAddress } from 'typescript/clients/solidshop/address_client';
import { useLocaleInfo } from 'typescript/context/locale_info';
import { ValidationRequestAddress } from 'typescript/types/api/address_validation';
import { MUTATION_KEYS } from 'typescript/constants/react_query';

export const useAddressValidation = () => {
  const { countryCode } = useLocaleInfo();
  const { mutate: validateAddress, ...rest } = useMutation({
    mutationKey: [MUTATION_KEYS.VALIDATE_ADDRESS],
    mutationFn: async (address: ValidationRequestAddress) => {
      const response = await clientValidateAddress({
        address_validation_request: {
          address: {
            ...address,
            country_code: countryCode,
          },
          save: false,
        },
      });

      return response.address_validation_result;
    },
    onError: (error, variables) =>
      captureException(new CustomError(MUTATION_KEYS.VALIDATE_ADDRESS, error), {
        extra: {
          variables: JSON.stringify(variables),
        },
      }),
  });

  return { validateAddress, ...rest };
};

export default useAddressValidation;
